import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { ChartModule } from 'primeng/chart';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { TreeTableModule } from 'primeng/treetable';
import { NgApexchartsModule } from 'ng-apexcharts';
import { ComumModule } from '../../../shared/comum.module';
import { translateLoaderNBS } from '../../../shared/translate-loader/translateLoader';
import { FluxoLeadsComponent } from './fluxo-leads.component';
import { FluxoLeadsService } from './fluxo-leads.service';


@NgModule({
  imports: [
    ComumModule,
    CommonModule,
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    NgbModule,
    TableModule,
    ButtonModule,
    CalendarModule,
    ChartModule,
    DialogModule,
    DropdownModule,
    TooltipModule,
    InputTextModule,
    ProgressSpinnerModule,
    TreeTableModule,
    NgApexchartsModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  exports: [
    FluxoLeadsComponent
  ],
  declarations: [
    FluxoLeadsComponent
  ],
  providers: [
    CurrencyPipe,
    FluxoLeadsService
  ]
})
export class FluxoLeadsModule { }
